module.exports = __webpack_public_path__ + "static/media/avatar3.fb84ab08.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatar3.jpeg
// module id = 306
// module chunks = 0